import CONSTANTS from './constants'

export const getSSOManageAccountLink = () => {
  return `${CONSTANTS.VITE_FUSIONAUTH_URL}/account/?client_id=${CONSTANTS.VITE_FUSIONAUTH_APP_CO_CLIENT_ID}`
}

export const getInsightsHubLink = () => {
  return CONSTANTS.VITE_INSIGHTS_APP_URL
}
